import { render, staticRenderFns } from "./newsEdit.vue?vue&type=template&id=6101888c&scoped=true"
import script from "./newsEdit.vue?vue&type=script&lang=js"
export * from "./newsEdit.vue?vue&type=script&lang=js"
import style0 from "./newsEdit.vue?vue&type=style&index=0&id=6101888c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6101888c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6101888c')) {
      api.createRecord('6101888c', component.options)
    } else {
      api.reload('6101888c', component.options)
    }
    module.hot.accept("./newsEdit.vue?vue&type=template&id=6101888c&scoped=true", function () {
      api.rerender('6101888c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/competition/newsEdit.vue"
export default component.exports